module.exports = __webpack_public_path__ + "img/6_110.52f535ce.png";